export default __webpack_public_path__ + "static/media/background-gray.a957e7d6.svg";